import React, { useEffect, useMemo } from 'react';
import { CalculationStatisticStoreTargetResponse } from '@ydistri/api-sdk';
import { useCurrency } from '../../../../hooks/useCurrency';
import { useApplicationData } from '../../../../hooks/useApplicationData';
import PrefilledTableTargetStore from '../../Statistics/modal/TargetStore/PrefilledTableTargetStore';
import { buildTargetStoreStats } from './targetStoreStats';
import { ChangelogSectionProps, parseChangelogData } from '../editRedistributionLib';

const ChangelogTargetStores: React.FC<ChangelogSectionProps> = ({
  stringifiedData,
  onStatsComputed,
}) => {
  const currency = useCurrency();
  const { departments: hasDepartments } = useApplicationData();

  const data = useMemo(
    () => parseChangelogData<CalculationStatisticStoreTargetResponse>(stringifiedData),
    [stringifiedData],
  );

  const useDepartments = data.some(i => i.department);

  useEffect(() => {
    onStatsComputed(buildTargetStoreStats(data, hasDepartments, currency));
  }, [data, hasDepartments, currency, onStatsComputed]);

  if (data.length === 0) return null;

  return (
    <PrefilledTableTargetStore data={data} displayDepartment={hasDepartments && useDepartments} />
  );
};

export default ChangelogTargetStores;
